import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "wedelvr_session_token";

export const setToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); };
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({
  baseURL: API,
  timeout: 60000,
  withCredentials: true,
});

// Attach Bearer token as a fallback when the browser blocks cross-origin
// cookies (common in Brave / Safari ITP / Chrome 3rd-party cookie blocking).
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    if (!config.headers.Authorization) config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export default api;
